<template>
    <div id="AddEds">
    <!-- <Subtitle  v-bind:ServiceID="this.AppServiceID">
       <template v-slot:header>
        <i class="fas fa-history"></i><b>Add EDS Standard:</b>
      </template> 
    </Subtitle> -->
    <!-- <b-modal id="AddCriteriaModel" size="lg" v-model="ShowCriteria"  no-close-on-esc no-close-on-backdrop hide-header-close
      ok-variant cancel-variant hide-footer
     header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant> 
     <EdsCriteria v-if="ShowCriteria==true" @criteriadone="closeModal"></EdsCriteria>
     <template slot="modal-header"   slot-scope="{ close }"> 
        <div>
        <small class="PopUpTitle w-100 text-left ml-2">{{Button}} EDS Criteria</small>
      </div> 
      <div v-show="Button=='Edit'"></div>
    </template>  
</b-modal> -->
     <form class="card  p-3 mb-1" id="SearchForm">
      <!-- {{SelectedMajor}} -->
      <div id="collapse-4" v-if="TblData.length==0">
      <div class="card-header d-flex align-items-center  pl-1" style="height: 1rem; text-align:left;">
            <h5><small class="text-muted"><b><i class="fas fa-search-plus"></i>Select EDS User Group and EDS Drugs:</b></small></h5>
      </div>
      <div class="form-row p-1" id="SearchBox"> 
        <div class="form-group col-sm-2">
          <label for="inputEmail4" class="label-small">User Type:</label>
          
          <select   v-model="selectedRole"   v-on:change="UserTypeChange($event)"  class="form-control form-control-sm">
          <option v-for="option in Roles" v-bind:value="option.id" :key="option.id">
            {{ option.text }}
          </option>
        </select> 
        
        <div calss="col-sm-12 my-0"   v-show="$v.selectedRole.$error" :class="{ 'col-sm-12 my-0': $v.selectedRole.$error}" >
              <div class="row">
                <small class="sml-red" v-if="!$v.selectedRole.required">User Type is required.</small>
              </div> 
        </div> 
      </div> 
        
        
        <!-- AHFS class -->
        <!-- <div class="form-group col-sm-4">
          <label for="inputEmail4" class="label-small">Search AHFS Class:</label>
          <div class="">
                  <vue-bootstrap-typeahead :inputClass="TypeHeadinptClass" id="clinicSel" ref="clinicRef"  @input="MajorChanged" v-model="MajorModel" :data="Majors"
                    @hit="SelectedMajor = $event; searched=false" :serializer="item => item.classid + ' | ' + item.majorminor.trim()"
                    textVariant=".text-primary" placeholder="Search AHFS Class" size="sm" backgroundVariant="bg-light"
                    :maxMatches="20" updateOn='blur' >
                    <template slot="prepend">
                      <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
                    </template>
                  </vue-bootstrap-typeahead>
          </div> 
        </div> -->
<!-- {{ BySingleDin }} -->
          
        <div class="form-group col-sm-2">
          <label   class="label-small">Add and Search By Brand Name:</label>
          <span class="form-control form-control-sm" style="border-style: hidden;">
          <toggle-button   class="" v-model="BySingleDin" :switch-color="{
              checked: '#25EF02',
              unchecked: 'linear-gradient(red, yellow)',
            }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" /> 
        </span> 
        </div>
          <!-- Brand Name serach
           {{ branddosage }}
          {{ selectedBrand }}  -->
        <div class="form-group col-sm-8" v-if="BySingleDin==true" >
          <label   class="label-small">Select Brand Name:</label>
          <div class="">
                  <vue-bootstrap-typeahead :inputClass="TypeHeadinptClass" id="BrandSel" ref="BrandRef"  @input="BrandtextChanged" v-model="branddosage" :data="brands"
                    @hit="selectedBrand = $event; searched=false" :serializer="item => item.brand + ' | ' + item.dosage"
                    textVariant=".text-primary" placeholder="Search Brand Name" size="sm" backgroundVariant="bg-light"
                    :maxMatches="20" updateOn='blur' >
                    <template slot="prepend">
                      <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
                    </template>
                  </vue-bootstrap-typeahead>
          </div> 
          <div v-if="BySingleDin==true"   v-show="$v.branddosage.$error" :class="{ 'col-sm-6 my-0': $v.branddosage.$error}" >
              <div class="row">
                <small class="sml-red" v-if="!$v.branddosage.needValue">Brand Name is required.</small>
              </div> 
          </div> 
          
        </div>

          <!-- Generic search 
          {{ genericName }}
           {{ selectedGenerics }}  -->
          <!-- @hit="selectedGenerics = $event; searched=false" :serializer="item => item.genericname" -->
        <div class="form-group col-sm-8" v-if="BySingleDin==false">
          <label  for="inputPassword4" class="label-small">Search Generic Drug: </label>
          <div >
            <!-- 
                <vue-bootstrap-typeahead :inputClass="TypeHeadinptClass" id="GenericRef" ref="GenericRef" @input="GenericChanged" v-model="genericName" :data="Generics"
                @hit="selectedGenerics = $event; searched=false" :serializer="item => item.genericname + ' | ' + item.dosage "
                  textVariant=".text-primary" placeholder="Search Generic EDS" size="sm" backgroundVariant="bg-light"
                  :maxMatches="20">
                  <template slot="prepend">
                    <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
                  </template>
                </vue-bootstrap-typeahead>
                
 {{ genericName }} -->
                <vue-bootstrap-typeahead :inputClass="TypeHeadinptClass" id="GenericRef" ref="GenericRef" @input="GenericChanged" v-model="genericName" :data="Generics"
                 
                @hit="selectedGenerics = $event; searched=false" :serializer="item => item.genericname" updateOn='blur'
                  textVariant=".text-primary" placeholder="Search Generic EDS" size="sm" backgroundVariant="bg-light"
                  :maxMatches="20">
                  <template slot="prepend">
                    <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
                  </template>
                </vue-bootstrap-typeahead>



      </div>
            <div class="row " v-if="BySingleDin==false">           
            <div class="col-sm-12">
                <small class="sml-red"><strong>Note: Please search and then select multiple strength and doses from the list given below. </strong></small>
            </div>
            </div> 
            <div v-if="BySingleDin==false"  v-show="$v.genericName.$error" :class="{ 'col-sm-6 my-0': $v.genericName.$error}" >
              <div class="row">
                <small class="sml-red" v-if="!$v.genericName.needValue">Generic Drug is required.</small>
              </div> 
            </div> 
        </div>
        
</div> 

        <div class="row mt-0" id="GenericDossage" v-show="SelectedGenName.length">
          <div class="col-12">
            <label class="p-0 m-0"><strong>Select multiple strength and doses:</strong> </label>

          </div>
      
            <div class="row ml-3 mr-2 mt-3" v-for="item in SelectedGenName" :key="item.id">
              <div class="checkbox ">
                <label>
                  <input id="ServSubCheck"  type="checkbox" class="pointer"
                   :value="item" v-model="selectedIDosage" />
                  <span class="cr"><i class="cr-icon fas fa-check"></i></span>
                  <span style="vertical-align: top"> {{item.dosage}}</span>
                </label>
              </div>
            
            </div> 
         
        </div>
              <div class="row" v-show="$v.selectedIDosage.$error" :class="{ 'col-sm-6 my-0': $v.selectedIDosage.$error}">
                <small class="sml-red" v-if="!$v.selectedIDosage.needValue">Please select strength and doses.</small>
              </div> 
        <!-- Generic search -->
        <!-- <div class="form-group col-sm-4">
          <label  for="inputPassword4" class="label-small">Search Generic Drug:</label>
          <div >
                <vue-bootstrap-typeahead :disabled="DisbleProvider" :inputClass="TypeHeadinptClass" id="provSel" ref="providerRef" @input="GenericChanged" v-model="genericName" :data="Generics"
                  @hit="selectedGenerics = $event; searched=false" :serializer="item => item.genericname"
                  textVariant=".text-primary" placeholder="Search EDS" size="sm" backgroundVariant="bg-light"
                  :maxMatches="20">
                  <template slot="prepend">
                    <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
                  </template>
                </vue-bootstrap-typeahead>
            </div> 
        </div> -->

        <!-- <div class="form-group col-sm-3"  >
          <label for="inputEmail4" class="label-small">Select Dosage</label>
          <div class="">
                  <vue-bootstrap-typeahead :inputClass="TypeHeadinptClass" id="clinicSel" ref="clinicRef"  @input="ClinictextChanged" v-model="clinicno" :data="clinics"
                    @hit="selectedClinic = $event; searched=false" :serializer="item => item.clinicname.trim() + ' (' + item.city.trim() + ', ' + item.province.trim() + ': ' + item.address.trim() + ')'"
                    textVariant=".text-primary" placeholder="Search Dosage" size="sm" backgroundVariant="bg-light"
                    :maxMatches="20" updateOn='blur' >
                    <template slot="prepend">
                      <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
                    </template>
                  </vue-bootstrap-typeahead>
          </div> 
        </div> -->

        <!-- <div class="form-group col-sm-1">
          <label for="inputEmail4" class="label-small">Add By Multiple DINs:</label>
          <toggle-button   v-model="BySingleDin" :switch-color="{
              checked: '#25EF02',
              unchecked: 'linear-gradient(red, yellow)',
            }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" /> 

        <div class="row" v-show="$v.HSN.$error">           
            <div class="col-sm-12">
                <small class="sml-red" v-if="!$v.HSN.required">HSN is required.</small>
            </div>
          </div>
          <div class="row" v-show="$v.HSN.$error">           
            <div class="col-sm-12">
               <small class="sml-red" v-if="!$v.HSN.minLength">Minimum 9 digit required.</small>
            </div>
          </div>
          <div class="row" v-show="$v.HSN.$error">           
            <div class="col-sm-12">
               <small class="sml-red" v-if="!$v.HSN.numeric">HSN must be a number.</small>
            </div>
          </div>
    
        </div> -->
      
   
         
      <!-- <div class="form-row p-1" id="SearchBox">

        <div class="form-group col-sm-4" v-if="BySingleDin==true" >
          <label for="inputEmail4" class="label-small">Select Brand Name:</label>
          <div class="">
                  <vue-bootstrap-typeahead :inputClass="TypeHeadinptClass" id="clinicSel" ref="clinicRef"  @input="ClinictextChanged" v-model="clinicno" :data="brands"
                    @hit="selectedClinic = $event; searched=false" :serializer="item => item.brand + ' | ' + item.dosage"
                    textVariant=".text-primary" placeholder="Search Brand Name" size="sm" backgroundVariant="bg-light"
                    :maxMatches="20" updateOn='blur' >
                    <template slot="prepend">
                      <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
                    </template>
                  </vue-bootstrap-typeahead>
          </div> 
        </div>

         
        <div class="form-group col-sm-4" v-if="BySingleDin==false">
          <label  for="inputPassword4" class="label-small">Search Generic Drug: </label>
          <div >
                <vue-bootstrap-typeahead :disabled="DisbleProvider" :inputClass="TypeHeadinptClass" id="provSel" ref="providerRef" @input="GenericChanged" v-model="genericName" :data="Generics"
                  @hit="selectedGenerics = $event; searched=false" :serializer="item => item.genericname + ' | ' + item.dosage + ' | ' + item.majorid"
                  textVariant=".text-primary" placeholder="Search Generic EDS" size="sm" backgroundVariant="bg-light"
                  :maxMatches="20">
                  <template slot="prepend">
                    <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
                  </template>
                </vue-bootstrap-typeahead>
            </div>
            <div class="row " v-if="BySingleDin==false">           
            <div class="col-sm-12">
                <small class="sml-red"><strong>Note Multiple Din's will be Selected and Added</strong></small>
            </div>
            </div> 
        </div> 
          
        
         <div class="form-group col-sm-4"  >
          <label for="inputEmail4" class="label-small">Select Dosage : </label>
          <div class="">
                  <vue-bootstrap-typeahead :inputClass="TypeHeadinptClass" id="clinicSel" ref="clinicRef"    v-model="DrugName" :data="Drugs"
                    @hit="SelectedDrugs = $event; searched=false" @input="SelectedDrugsChanged" :serializer="item => item.drugdosage.trim()"
                    textVariant=".text-primary" placeholder="Search Dosage" size="sm" backgroundVariant="bg-light"
                    :maxMatches="20" updateOn='blur' >
                    <template slot="prepend">
                      <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
                    </template>
                  </vue-bootstrap-typeahead>
          </div> 
        </div> 
      </div>  -->
 
      <!-- backdating -->
      <div class="form-row p-1" id="SearchBox">
      
          <div class="form-group col-sm-2">
          <label for="inputEmail4" class="label-small">Back Dating EDS Request Allowed:</label>
          <span class="form-control form-control-sm" style="border-style: hidden;">
          <toggle-button   class="" v-model="IsBackDating" :switch-color="{
              checked: '#25EF02',
              unchecked: 'linear-gradient(red, yellow)',
            }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" /> 
        </span>
        <!-- <div class="row" v-show="$v.HSN.$error">           
            <div class="col-sm-12">
                <small class="sml-red" v-if="!$v.HSN.required">HSN is required.</small>
            </div>
          </div>
          <div class="row" v-show="$v.HSN.$error">           
            <div class="col-sm-12">
                <small class="sml-red" v-if="!$v.HSN.minLength">Minimum 9 digit required.</small>
            </div>
          </div>
          <div class="row" v-show="$v.HSN.$error">           
            <div class="col-sm-12">
                <small class="sml-red" v-if="!$v.HSN.numeric">HSN must be a number.</small>
            </div>
          </div> -->

        </div>

        <!-- <div class="form-group col-sm-1"  v-if="IsBackDating==true" > -->

        <div class="form-group col-sm-1"  v-if="IsBackDating==true" >
          <label for="bkunits" class="label-small">Unit:</label> 
          <div class="">
            <select   id="bkunits" v-model="bkunit"
                  class="m-0 p-0 form-control form-control-xs">
                  <option v-for="option in backdatingunits" v-bind:value="option.id"  
                    :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
          </div> 
          <div v-if="IsBackDating==true" v-show="$v.bkunit.$error" :class="{ '': $v.bkunit.$error}" >
              <div class="row">
                <small class="sml-red" v-if="!$v.bkunit.needValue">Unit is required.</small>
              </div> 
            </div> 
        </div>
      
        <div class="form-group col-sm-1" v-if="IsBackDating==true">
          <label for="inputEmail4" class="label-small">Length:</label>
          <div class="">
              <input maxlength="2" type="text>" class="form-control form-control-xs" v-model="bkdays">
          </div> 
          <div v-if="IsBackDating==true" v-show="$v.bkdays.$error" :class="{ '': $v.bkdays.$error}" >
              <div class="row">
                <small class="sml-red" v-if="!$v.bkdays.needValue">Days is required.</small>
                <small class="sml-red" v-if="!$v.bkdays.numeric">must be numeric.</small> 
                <!-- <small class="sml-red" v-if="!$v.bkdays.nonZero">must be greater than zero.</small>  -->
              </div> 
            </div> 
        </div> 
          <div class="form-group col-sm-2">
                <label for="inputPassword4" class="label-small">Effective Date:</label>
                <div>                  
                    <datepicker class="servdatapick"  :open-date="new Date()" v-model="fromDate" 
                      :format="DateFormat" id="effDate" :bootstrap-styling="true" :input-class="datapickClass"
                      name="fromDatepicker"></datepicker>
                </div> 
                <div  class="row" v-show="$v.fromDate.$error">
                  <div class="col-sm-12"> 
                     <small class="sml-red" v-if="!$v.fromDate.required">Valid from date is required.</small>
                    <small class="sml-red" v-if="!$v.fromDate.needValue">Valid from date is required.</small>
                </div>
                </div>
          </div>
           
          <div class="form-group col-sm-6">
                <label for="inputPassword4" class="label-small">Expiry Date:</label>
                <div class="row">
                  <div class="col-sm-4 my-0">                    
                    <datepicker class="servdatapick"  :open-date="new Date()" v-model="toDate" :format="DateFormat" 
                        id="toDate" :bootstrap-styling="true" :input-class="datapickClass" name="toDatepicker"></datepicker>              
                  </div>
                  <div class="col-sm-8 my-0">
                  <template>
                        <RadioToggleButtons class="form-control-xs" v-model="toDate" :values="OpenEndedDate" color="#006537"
                          textColor="#000" selectedTextColor="#fff" /><span class="form-control-xs" v-on:click="toDate = ''" style="font-size: 1em;">
                            <!-- <i
                            class="fas fa-times ml-2 pointer"></i> -->
                        </span>
                      </template>
                </div>
                
             </div>
             <div  class="row my-0 pt-0 mt-0 no-gutter" v-show="$v.toDate.$error">
                    <div class="col-sm-12 my-0"> 
                      <small class="sml-red" v-if="!$v.toDate.required">Valid to date is required.</small>
                      <small class="sml-red" v-if="!$v.toDate.needValue">Valid to date is required.</small> 
                    </div> 
                </div>

          </div>
          <div class="form-group col-sm-3">
                <label for="inputPassword4" class="label-small"> </label>
                <div class="">

                </div>
          </div>
      </div> 
      <div class="row  p-2">
                <div class="col-sm-2">
                  <button type="button"  :class="visible ? null : 'collapsed'"
                        :aria-expanded="visible ? 'true' : 'false'"
                        aria-controls="collapse-4"   
                        v-on:click="SubmitEds" class="btn btn-primary form-control" >Submit</button>
                  </div>
                
                  <div class="col-sm-2">
                    
                  </div>
                  <div class="col-sm-2">
                    <button type="button"  v-on:click="CloseEds" class="btn btn-primary form-control" >Close</button>
                  </div>

                  <!-- <div class="col-sm-6">
                    <button v-on:click="ShowCriteria=true" v-show="true" type="button" class="btn btn-warning btn-sml mt-1 float-right">
                    Add Daignosis and Criteria
                  </button>
                  </div> -->
              
      </div>

      </div>
        <!-- <div class="row m-2 ml-3">
          <div class="col-4 float-left">
            User Group: Community EDS
          </div>
          <div class="col-4">
            <button v-on:click="ShowCriteria=true" v-show="true" type="button" class="btn btn-warning btn-sml mt-1 float-right">
              Add Daignosis and Criteria
            </button>
          </div>
        </div> -->
        <transition name="slide-fade">  
        <div class="row" v-if=" this.UserEdsRecid > 0 ">
          <!-- <div class="row"> -->
          <div class="col-12">
            <!-- <ViewUserCriteria :useredsid="UserEdsRecid"></ViewUserCriteria> -->
                <!-- <v-client-table  :columns="columns"  :data="TblData" :options="options">  
                <div slot="beforeTable"  class="form-group row VueTables_Adduser Maintitle mr-1 ml-1"> 
                <div class="col-4 float-left mt-1 pl-1">
                <strong>EDS Drugs For: Community EDS</strong>
                </div> 

                </div>
                </v-client-table> -->

          </div>
          <div class="col-12">
            <b-table striped hover :items="rowdata" :fields="fields"></b-table>
            <EDSCriteriaAdd @exitpage="exitpage" :EdsRecID = "UserEdsRecid" :mode="mode" @criteriadone="CloseEds"></EDSCriteriaAdd>
          </div>
        </div>
          </transition>  
          <div >

        <div class="row">
          <div>
           
            <!-- <view-criteria @exitpage="exitpage" :EdsRecID = "UserEdsRecid"></view-criteria> -->
          </div>
        </div>
          </div>
      
</form>
 
    </div>
    </template> 
    <script>
    import Vue from 'vue'; 
    import { ref } from 'vue';
    import {mapGetters} from 'vuex'
    import moment from 'moment'
    import axios from 'axios' 
    import Datepicker from 'vuejs-datepicker';
    import LayoutDefault from '@/Common/Default/DefaultLayout.vue'; 
    import Subtitle from '@/Common/Default/SubTitle.vue'; 
    import Modal from '@/Common/ModelPop.vue';
    import Card from "@/Common/Card.vue";
    import CardBody from "@/Common/CardBody.vue";
    import TileNote from "@/Common/TileNote.vue";
    import { PopUpVariant } from '@/Common/Default/PopUpVariant';
    import { request } from 'http';
    import EDSCriteriaAdd from '@/components/DPEBB/Administrator/EDSCriteriaAdd.vue'
    import ViewUserCriteria from '@/components/DPEBB/Administrator/ViewUserCriteria.vue'
    //import ViewCriteria from '@/components/DPEBB/Administrator/ViewCriteria.vue'
    //import AddEDSCriteria from '@/components/DPEBB/Administrator/AddEDSCriteria.vue'
    import Vuelidate from 'vuelidate'
    import {helpers, required, minLength, sameAs, not, maxLength, numeric, integer, between} from 'vuelidate/lib/validators'
    
    Vue.use(Vuelidate);
    export default  {
      props: {
          Type: '1'
      },
      name: 'AddEDS',
      data: function () {
        
        return {
        selectedIDosage: [],
        GenericDosage  :[],
        SelectedGenName :[],
          OpenEndedDate: [
        { label: "Open Ended Date", value: "9999/12/31" },
      ],
          fields: [
    
    //expirydate
      {
        key: 'role',
        label: 'User Type', 
      },
      {
        key: 'brandname',
        label: 'Brand/Generic Name',
        //sortable: false
      },
      {
        key: 'dosage',
        label: 'Dosage', 
      },
      {
        key: 'din',
        label: 'Din',
        //sortable: true,
        // Variant applies to the whole column, including the header and footer
        //variant: 'danger'
      },
      {key:'effectivedate', label :'Effective Date' ,formatter: "momentdate" },
    {key:'expirydate', label :'Expiry Date' ,formatter: "momentdate"},
    ],
    rowdata  : [], 
          mode: 'Add',
          tblrow: '',
          UserEdsRecid :0,
          bkunit : '',
          bkdays : '0',
                  backdatingunits: [
                    { id: "M", text: "Months" },
                    { id: "D", text: "Days" },
                  ],
                  brands : [] ,
                  Drugs :[],
                  DrugName: '',
                  SelectedDrugs: '',
                  Generics : [],
                  selectedGenerics : null,
                  genericName : '',
                  SelectedMajor:null,
                  MajorModel: '',
                  Majors : [],
                  Roles: [],
                  visible: true,
                  Button:'',
                  selectedRole: '',
                  ShowCriteria: false,
                  IsBackDating: false,
                  BySingleDin: true,
                  PrescName:'',
                  Comments:'', 
                  MsgPopup :'',
                  showError: false,
                  TypeHeadinptClass:'form-control form-control-xs',
                  boxTwo: '',
                  BtnSubmitdisabled:0,
                  primaryText:'',
                  PaidByThirdPArty:false,
                  browseText:'Click Here',
                  AppServiceID:1, 
                  AppName:'',
                  title:"EDS STANDARD",
                  subtitle: "Welcome", 
                  HSN:'',
                  fromDate: '',
                  toDate: '',
                  serviceDate: '',
                  DateFormat:'',
                  datapickClass:"form-control form-control-xs my-0",
                  showInfo : false, 
                  selectedProvider: null,
                  detailProvider: null, 
                  branddosage: '',
                  selectedBrand: null, 
                  TblData: [], 
                  PopUpVar:PopUpVariant,
                  showDetailModal: false,
                  showMessageModal: false,
                  searched:false,   
              columns: [ 'dosage','din', 'brandname','effectivedate','expirydate','backdating','bkunit', 'bklength', 'singledin','createdby','modifyby'],
    
              options: {
              texts:{
                //count:"Showing {from} to {to} of {count} records|{count} records|One record",
                first:'First',
                last:'Last',
                //limit:"Records:",
                //page:"Page:",
                //noResults:"No Eds Record Found",
                filterBy:"Filter by {column}",
                loading:'Loading...',
                defaultOption:'Select {column}',
                columns:'Columns'
              },
              headings: { 
                dosage: "Dosage",
                din: "Din",
                brandname: "Brand name",
                effectivedate: "Effective Date",
                expirydate: "Expiry Date",
                createdby: "Created By",
                modifyby: "Modify By",
                backdating: "Back Dating",
                bkunit: "Unit",
                bklength:"Length",
                singledin:"Added By Multiple Dins"

              },
    
              responseAdapter({data}) {
                return {
                  data: formatData,
                  count: data.length
                };
              },
              summary: false,
              caption: false,
              perPage:5,
              perPageValues:[5],    
              dateColumns:['effectivedate','expirydate'],
              footerHeadings: false,
              filterable: false,
    
              // listColumns: {
              //   claimtype: [
              //     {id: "CL",
              //     text: "Claim"},
              //     {id: "PA",
              //     text: "Prior Approval"}
              //   ]
              // },
    
              templates: {
                effectivedate(h, row) {         
                  return moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');  
                },  
                expirydate(h, row) {         
                  return moment(row.expirydate,"YYYY-MM-DD").format('YYYY/MM/DD');  
                },
                singledin(h, row) {
                if(row.singledin ==true)
                      return "NO"
                  else
                  return  "YES"
                  },
                  backdating(h, row) {
                if(row.backdating ==true)
                      return "Yes"
                  else
                  return  "No"
                  },
              },
    
      
              pagination: {
               
                nav: 'scroll',
                chunk: 5,
                show:false,
                dropdown: false,
               
                edge: false,
                align: "center",
                nav: "fixed"
              },
    
              //sortable: ['servicedate', 'priorapprvno' ,  'providerno', 'clinicno', 'claimtype', 'servicetype'],
              sortable:[],
              sortIcon: {
                      base : 'fas',
                      is: 'fa-sort',
                      up: 'fa-sort-up',
                      down: 'fa-sort-down'
              },
            },
          }
        },
    wacth: {
  
    //   SelectedDrugs :function(){
    //   if(this.SelectedDrugs !=null && this.SelectedDrugs !='')
    //   {
    //     //this.GetDrugs();
    //     //console.log(' SC = ' + this.SelectedDrugs.id)
    //   }
    //   else
    //   {
         
    //   } 
    // },

    // selectedGenerics :function(){
    //   //console.log(selectedGenerics)
    //   if(this.selectedGenerics !=null && this.selectedGenerics !='')
    //   {
    //     this.GetDrugs();
    //     //console.log(' SC = ' + this.selectedGenerics.id)
    //   }
    //   else
    //   {
         
    //   }
    
    // }
  },
        components: { 
          EDSCriteriaAdd,
          ViewUserCriteria,
          //  ViewCriteria,
                Card,
                CardBody,
                TileNote ,
                Datepicker,
                // EdsCriteria,
                Subtitle,
                Modal:Modal,
        },
        
        

        validations(){
          return { 
            selectedIDosage :{
                //required
                needValue : value=> this.ValidateGeneric()
            },
            selectedRole :{
                 required
            }, 

            branddosage:{
                //required: value=> (this.BySingleDin == true)
                needValue: value=>  this.ValidateBranddosage(),

            },
            genericName:{
              needValue: value=>  this.ValidateGeneric(),
            },
            bkunit:{
                //required: this.IsBackDating==true
                needValue: value=>  this.ValidateBkunit(),
            },
            bkdays:{
                needValue: value=>  this.ValidateBkdays(),
                numeric,
                // nonZero: value=> (this.bkdays != null && (this.bkdays != 0))
            },
            toDate:{
                required,
                 needValue: value=>  this.ValidatetoDate(),
           },    
           fromDate:{
                required,
                 needValue: value=>  this.ValidatefromDate(), 
           },    
          }
        },
    
        filters: {
          moment: function (date) {
            return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
          },
          stringify(value) {
            return JSON.stringify(value, null, 2)
          }  
        }, 
        watch:{
          BySingleDin:function(){
          if(this.BySingleDin == false)
          {
            
             this.showMsg('Please Select Multiple Strength and doses from the list.', '','Eds Allocation Message')
             
          }
          else
          {
             this.SelectedGenName = [];
             this.genericName='';
             // this.Drugs=[];
          }

      },
      selectedGenerics: function(){
        if(this.selectedGenerics !=null && this.selectedGenerics !='')
            {
 
              this.SelectedGenName  = this.searchResult();
              //console.log  (' at SelectedGenName =  ' + this.SelectedGenName)

            }
            else
            {
                  this.SelectedGenName = [];
                  this.genericName='';
                 // this.Drugs=[];
            }
          }
    },
      methods: {
        searchResult() {
            
             let FilterGen = this.GenericDosage;
             //console.log(' At Search Filter Gen' + FilterGen)
            if (this.selectedGenerics != '' && this.selectedGenerics !== null) {
             
                  FilterGen = this.GenericDosage.filter((item) => {
                        //console.log('item = ' +item.genericname)
                        return (item.genericname === this.selectedGenerics.genericname)
                      })
                   
                }

              return FilterGen;
            },
        GetUserEds(){
      //console.log('eds id =  '+ this.UserEdsRecid)
          var vm = this;      
          vm.searched = false;
          var params = new URLSearchParams();            
           params.append('edsrec',  this.UserEdsRecid);         
           axios.get('SaskHealthApi/Codes/GetUsersEDSAllocation?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
           .then(function (response) {
               //vm.TblData=response.data; 
               //var r   = JSON.parse(JSON.stringify(response.data))
                vm.rowdata.push(response.data[0])
                //console.log(vm.rowdata)             
            })
            .catch(function (er) {
                //console.log(er)
            });
          },
        momentdate: function (date) {
            return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
          },
        clearallData(){
          this.genericName='';
            this.UserEdsRecid =0;
            this.TblData = [];
            this.selectedBrand=null;
            this.selectedGenerics=null;
            this.branddosage = '';
            this.selectedRole= '';
            this.toDate ='';
            this.fromDate = '';
            
        },
        exitpage(val)
        {
          // const refreshPage = () => {
          //   window.location.reload();  // Reloads the current page
          // };
          this.clearallData();
          this.$emit("loadmainedstbl");
          // emit loadmainedstbl
          //this.loadTable();
          ////console.log(' at exit route   = ' + val)
          //this.visible = false;
        },
        detail(){

        },
        SubmitEds: function(){ 
        ////console.log("Submit Recieved - inside the function");
         this.$v.$touch();
         ////console.log(!this.$v.$invalid);
       if (!this.$v.$invalid){
        ////console.log("Submit Inside");
            var vm = this;
            var frm = "";
            var to = "";  
            var  SelectedGen=[];  
            if(vm.selectedIDosage !== null && vm.selectedIDosage !== "")
                SelectedGen = vm.selectedIDosage.map(sel =>({
                  din : sel.din, dosage : sel.dosage
              }));
            if (vm.fromDate == "" || vm.fromDate == null) frm = "00000000";
            else frm = moment(vm.fromDate, "YYYY-MM-DD").format("YYYY-MM-DD");
            if (vm.toDate == "" || vm.toDate == null) to = "00000000";
            else to = moment(vm.toDate, "YYYY-MM-DD").format("YYYY-MM-DD");
            // //console.log(effDate)
            // //console.log(expDate)
            var selecteddin;
            var selecteddosage;
            var selectedbrandname;
            if(vm.BySingleDin == true)
            {
                selecteddin = vm.selectedBrand.din;
                selecteddosage =  vm.selectedBrand.dosage;
                selectedbrandname = vm.selectedBrand.brand;  
            }
            else
            {
                selecteddin = 0;
                selecteddosage =  "";
                selectedbrandname =  vm.selectedGenerics.genericname;
            }
            vm.bkdays == "" ? 0 : vm.bkdays;
            //console.log(" bk days " + vm.bkdays )
            ////console.log( selecteddin + "," + selecteddosage + "| " + selectedbrandname)
            //console.log( frm + "," + to)
            //console.log( "Role = " + vm.selectedRole)
            var vm = this;
            var url = "SaskHealthApi/Codes/PostEdsStandard/"
           
             var params = {
                "_": Date.now(), 
                "Mode": "A",
                "RoleID" : vm.selectedRole,
                "Dosage":selecteddosage,
                "DIN": selecteddin,
                "BrandName": selectedbrandname,
                "BySingleDin" :   vm.BySingleDin,
                "EffectiveDate" : frm,
                "ExpiryDate" : to,
                "BackDatingAllow" :  vm.IsBackDating,
                "BackDatingUnit" : vm.bkunit,
                "BackDatingLength" : vm.bkdays,  
                "SelectedGenricDins" : SelectedGen
                } 

                //console.log('prams  =  ' + params)
                axios({
                    method: 'post',
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
                    data: params
                    }).then(function (response) {
                        //console.log(response)
                        if(response.data.result > 0 )
                        {
                          vm.UserEdsRecid = response.data.result;
                          vm.GetUserEds();
                       //   vm.visible = true;
                        //  vm.loadTable();
                        }
                        else

                        {
                          vm.showMsg(response.data.msg , '', 'EDS Allocation Error');
                        }
                        
                        
                })
                .catch(function (er) { 
                  //console.log('at er ' + er)
                  vm.visible = false;
                  if(er.response.status ==400)
                  {
                    vm.showMsg('System Error, please contact Administrator for more details.' , '', 'EDS error: system Error on save');
                  }
                  else if(er.response.status == 500)
                  {
                    vm.showMsg('System Error, please contact Administrator for more details.' , '', 'EDS error: system Error on save');
                   }                 
                }).then(function () { 
                    if(vm.UserEdsRecid > 0)
                    {

                      vm.visible=true;
                      vm.loadTable();
                    } 
                    else
                    {
                      vm.visible=false;
                    } 

                }); 
                
      }
    },
          CloseEds: function() {
            
            this.$emit("stddone", this.UserEdsRecid);
          },
          
        closeModal() { 
          //console.log('heee')
            this.ShowCriteria = false; 
            
        },
        ShowCriteriapop()
        {
            //console.log('here')
            this.showError==true;
        },
        UserTypeChange(){},
        radiochange(value){
          //console.log('radio value ' + value)
        },
        Go(){
            this.$router.push('/DPEBB/MainHome')
        },
        ClosePopup(){
          this.showError =false;
        },
        Show(){
              this.showInfo =true;
        }, 
        //GetAllRolesByServiceID GetMajorClass // GetAllBrands

        GetRoles(){         
          var vm = this;      
         var local = [];
            var params = new URLSearchParams();
            params.append('ServiceID', 1);
            axios.get('SaskHealthApi/Codes/GetAllRolesByServiceID', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
              .then(function (response) {
                vm.Roles =response.data;   
                //vm.loadTable(); 
                //vm.searched = true;
              })
              .catch(function (er) {
                //console.log(er)
               // vm.TblData = []; 
              if (er.response) {
                  if(er.response.status == 400)
                    {
                            if( er.response.data.message.length)
                            {
                            vm.showMsg(er.response.data.message,"","User Type Search Error");
    
                            }
                    }
                    else 
                  vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
    
                  }
                  else 
                   vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
                         
               
              })
             
        },
        GetAllBrands(){         
          var vm = this;      
         var local = [];
            var params = new URLSearchParams();
           // params.append('ServiceID', 1);
            axios.get('SaskHealthApi/Codes/GetAllBrands', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
              .then(function (response) {
                vm.brands =response.data;   
                //vm.loadTable(); 
                //vm.searched = true;
              })
              .catch(function (er) {
                //console.log(er)
               // vm.TblData = []; 
              if (er.response) {
                  if(er.response.status == 400)
                    {
                            if( er.response.data.message.length)
                            {
                            vm.showMsg(er.response.data.message,"","User Type Search Error");
    
                            }
                    }
                    else 
                  vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
    
                  }
                  else 
                   vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
                         
               
              })
             
        },

        GetAllGenerics(){         
          var vm = this;      
      var drugslocal = [];
            var params = new URLSearchParams();
           // params.append('ServiceID', 1);
            axios.get('SaskHealthApi/Codes/GetAllGenerics', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
              .then(function (response) {
                vm.GenericDosage =response.data;   
                //vm.loadTable(); 
                //vm.searched = true;
              })
              .catch(function (er) {
                //console.log(er)
               // vm.TblData = []; 
              if (er.response) {
                  if(er.response.status == 400)
                    {
                            if( er.response.data.message.length)
                            {
                            vm.showMsg(er.response.data.message,"","User Type Search Error");
    
                            }
                    }
                    else 
                  vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
    
                  }
                  else 
                   vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
                         
               
              })
             
        },

         GetAllGenericNames(){         
          var vm = this;      
          var drugslocal = [];
            var params = new URLSearchParams();
           // params.append('ServiceID', 1);
            axios.get('SaskHealthApi/Codes/GetAllGenericNames', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
              .then(function (response) {
                vm.Generics =response.data;   
                
              })
              .catch(function (er) {
                //console.log(er)
               // vm.TblData = []; 
              if (er.response) {
                  if(er.response.status == 400)
                    {
                            if( er.response.data.message.length)
                            {
                            vm.showMsg(er.response.data.message,"","User Type Search Error");
    
                            }
                    }
                    else 
                  vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
    
                  }
                  else 
                   vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
                         
               
              })
             
        },

        loadTable(){
      //console.log('eds id =  '+ this.UserEdsRecid)
          var vm = this;      
          vm.searched = false;
          var params = new URLSearchParams();            
           params.append('edsrec',  this.UserEdsRecid);         
           axios.get('SaskHealthApi/Codes/GetUsersEDSAllocation?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
           .then(function (response) {
               vm.TblData=response.data;              
            })
            .catch(function (er) {
                //console.log(er)
            });
          },
    
        showMsg(msg,data,Title) {
              this.boxTwo = ''
              this.$bvModal.msgBoxOk(msg, {
              title: Title,
              size: 'md',
              buttonSize: 'md',
              okVariant: 'danger',          
              okTitle: 'Close', 
              footerClass: 'p-2',
              hideHeaderClose: true,
              hideHeaderCancel: true,
              centered: true, 
            })
              .then(value => {
                
    
                this.boxTwo = this.msg;
                if(value)
                {
                 
                }
              })
              .catch(err => {
                // An error occurred
              })
          },
        MajorChanged(){
          if(this.clinicno == ''){
            this.SelectedMajor = null;
            this.searched = false;
          }
        },
        GenericChanged(){
          console.log  (' at geenric' + this.selectedGenerics)
        if(this.selectedGenerics !=null && this.selectedGenerics !='')
        {
              this.SelectedGenName = [];
        }
          //console.log('selectedgenerics' + this.selectedGenerics)
          // if(this.selectedGenerics !=null && this.selectedGenerics !='')
          // {
          //   //this.GetDrugs();
          //   //console.log(' SC = ' + this.selectedGenerics.id)
          //   //this.SelectedGenName = 
          //   this.SelectedGenName  = this.searchResult();
          //   console.log  (' at SelectedGenName =  ' + this.SelectedGenName)

          // }
          // else
          // {
          //       this.Drugs=[];
          // }
          //console.log('drugname '+this.DrugName)
          //console.log('drug after' + this.Drugs)
        },
        HSNtextChanged(){
          // if(this.HSN == null || this.HSN.length < 9){
          //   this.patient = null;
          //   this.searched = false;
          // }
        },
        CheckProvider(){
          //this.selectedProvider = this.providers.find(x=>x.providerno == this.providerName);
        },
        
        ValidateBranddosage(){   
        ////console.log('list:'+this.fileList)
        if(this.BySingleDin == true)
        {
           ////console.log('list:'+this.fileList)
            if(this.branddosage =='' || this.branddosage ==null ){
              return false;
            }
            else if (this.branddosage !=null)
            {
              return true;
            }
        }
        else
        {
          return true;
        }
      },

      ValidateGeneric(){   
       
        if(this.BySingleDin == false)
        {
          
            if(this.selectedIDosage =='' || this.selectedIDosage ==null ){
              return false;
            }
            else if (this.selectedIDosage !=null)
            {
              return true;
            }
        }
        else
        {
          return true;
        }
      },

      ValidateBkunit(){   
        ////console.log('list:'+this.fileList)
        if(this.IsBackDating==true)
        {
           ////console.log('list:'+this.fileList)
            if(this.bkunit =='' || this.bkunit ==null ){
              return false;
            }
            else if (this.bkunit !=null)
            {
              return true;
            }
        }
        else
        {
          return true;
        }
      },

      ValidateBkdays(){   
        ////console.log('list:'+this.fileList)
        
        if(this.IsBackDating==true)
        {
           ////console.log('list:'+this.fileList)
            if(this.bkdays =='' || this.bkdays ==null || this.bkdays == 0){
              return false;
            }
            else if (this.bkdays !=null)
            {
              return true;
            }
        }
        else
        {
          return true;
        }
      },

        ValidatetoDate(){
            //  //console.log('ValidatetoDate this.todate: '+ this.toDate);
            //   var isafter = moment(this.toDate).isAfter('1970/01/01', 'year');
            // //  //console.log('toDate isafter: ' + isafter);          
            //   if (isafter == false)  
            //   {
            // //    //console.log('toDate not greater than 1970!!!!');
            //     return false;  
            //   }
            //   else
            //   {
            // //     //console.log('toDate greater than 1970');
            //   }      
          if((this.toDate == '' || this.toDate ==null) && (this.fromDate != '' && this.fromDate != null))
            {
              return false;
            }
            else if((this.toDate != '' || this.toDate !=null) && (this.fromDate != '' && this.fromDate != null))
            {
              if(moment(this.fromDate).toISOString() <= moment(this.toDate).toISOString())
              {
                  return true;
              }  
              else
              return false;
            }
            else if((this.toDate != '' || this.toDate !=null) && (this.fromDate == '' || this.fromDate == null))
            {
                return true;
            }
            else
            {
            return false;
            }
    
          },
        ValidatefromDate(){
              ////console.log('ValidatefromDate this.fromdate: '+ this.fromDate);      
            //   var isafter = moment(this.fromDate).isAfter('1970/01/01', 'year');  // false 
            //   ////console.log('fromdate isafter: ' + isafter);
            //   if (isafter == false)
            //   {
            //  //   //console.log('from Date not greater than 1970!!!! ');
            //     return false;      
            //   }
            //   else
            //   {
            //   //   //console.log('fromDate greater than 1970');
            //   }  
          if((this.fromDate == '' || this.fromDate ==null) && (this.toDate != '' && this.toDate !=null ))               
            {
           
              if(moment(this.fromDate).toISOString() < moment(this.toDate).toISOString())
              {
                  return true;
              }  
              else
              return false;
            }
            else
            {
                return true;
            }
          },      
      
      
      
      GetUserClinics(){
               var vm = this; 
               var params = new URLSearchParams();
              params.append('ServiceID', this.AppServiceID);
                axios.get('/SaskHealthApi/Codes/GetUserClinic', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }, params})
                    .then(function (response) {
                        vm.clinics = response.data;
                        if(!vm.isAssessor){
                          vm.selectedClinic= vm.clinics[0];
                          vm.clinicno = vm.clinics[0].clinicno.toString();
                          vm.columns = ['view',  "claimtypedescription" ,'servicedate', 'priorapprvno','providerno' , 'name'];
                        } 
                        // //console.log(vm.selectedClinic);
                    })
                .catch(function (er) {
                    //console.log(er)
                })   
            },
     BrandtextChanged(){
            // if(this.clinicno == ''){
            //   this.selectedClinic = null;
            //   this.searched = false;
            // }
              
          },
          SelectedDrugsChanged(){
          //   if(this.DrugName == ''){
          //     this.SelectedDrugs = null;
          //     this.searched = false;
          //   }
          //   else
          //   {
          //     this.GetDrugs();
          //   }
              
           },
    
        CloseDetailModal() {
          this.showDetailModal = false;
        },
     
      },
    
      computed:{
          UserName(){
              return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
          },
          AllAppLevel(){
              return this.$store.getters.GetAllApplevel;
            },
 
      }, 
    
      created: function() {   
        //this.UserEdsRecid= 9; 
        this.AppServiceID = this.$store.getters.GetDPEBBServiceID; 
       this.$emit('update:layout', LayoutDefault);        
        this.DateFormat = this.$store.getters.GetDateFormat;  
        this.toDate = moment(this.TblData.toDate==undefined?'9999/12/31':this.TblData.toDate, "YYYY-MM-DD").format('YYYY/MM/DD');

        ////console.log('Exp Date is: ' + this.toDate) 

        this.GetAllBrands();
        this.GetAllGenerics();
        this.GetAllGenericNames();
        this.GetRoles();
        this.loadTable();
      },
    
      beforeCreate: function() {  
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
      },
    
      mounted: function () {
        
      },
    }
     
    
    </script>
    
    <style scopped>



.list-group-item {
  position: relative;
  display: block;
  padding: 0px 15px;
  margin-bottom: -1px;
  border: 1px solid #ddd;
  background-color: blue;
  line-height: 1em;
}

input[type="radio"].with-font,
input[type="checkbox"].with-font {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* input[type=radio].with-font ~ label:before, */
input[type="checkbox"].with-font~label:before {
  /* font-family: FontAwesome; */
  display: inline-block;
  content: "\f1db";
  letter-spacing: 7px;
  font-size: 1em;
  color: #535353;
  width: 1.2em;
}

input[type="radio"].with-font:checked~label:before,
input[type="checkbox"].with-font:checked~label:before {
  content: "\f00c";
  font-size: 1.2em;
  color: darkgreen;
  letter-spacing: 5px;
}

input[type="checkbox"].with-font~label:before {
  content: "\f096";
}

input[type="checkbox"].with-font:checked~label:before {
  content: "\f046";
  color: darkgreen;
}

input[type="radio"].with-font:focus~label:before,
input[type="checkbox"].with-font:focus~label:before,
input[type="radio"].with-font:focus~label,
input[type="checkbox"].with-font:focus~label {
  color: green;
  vertical-align: text-top;
}

.checkbox label:after {
  content: "";
  display: table;
  clear: both;
}

.checkbox .cr {
  position: relative;
  display: inline-block;
  border: 1px solid #a9a9a9;
  border-radius: 0.25em;
  width: 1.2em;
  height: 1.2em;
  /* float: left; */
  margin-right: 0.5em;
}

.checkbox .cr .cr-icon {
  position: absolute;
  font-size: 0.7em;
  line-height: 0;
  top: 50%;
  left: 15%;
}

.checkbox label input[type="checkbox"] {
  display: none;
}

.checkbox label input[type="checkbox"]+.cr>.cr-icon {
  opacity: 0;
}

.checkbox label input[type="checkbox"]:checked+.cr>.cr-icon {
  opacity: 1;
}

.checkbox label input[type="checkbox"]:disabled+.cr {
  opacity: 0.5;
}


    custom-control-label {
      position: relative;
      margin-bottom: 0;
  }
   
  label {
      display: inline-block;
      margin-bottom: .5rem;
  }
     .row.no-gutter [class*='col-']   {
       padding-right:1px;
       
     }
     .list-group-item {
        position: relative;
        display: block;
        padding: 0px 15px;
        margin-bottom: -1px;
        border: 1px solid #ddd;
        background-color: blue;
        line-height: 1em
    }
    .col-lg-1>div {background-color:#ddd;}
    
    #docimg {
       
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50; 
    }
    #line {
      border-top:1px solid   rgba(7, 14, 109, 0.25);
    }
    
    
    .test-modal .modal {
        padding: 0 !important;
        padding-left: 0px !important;
        overflow-y: scroll;
    }
    
    .test-modal .modal-dialog { 
        max-width: 100%;
        height: 100%;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        z-index: 100000;
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
    
    .modal-open {
        padding: 0 !important;
        padding-left: 0px !important;
        overflow-y: scroll;
    }
    
    #phModal {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
     
    </style>